/** Officer-facing copy for Off-Ramp Check. Change wording here — not in panels. */

export const PAGE = {
    title: 'Off-Ramp Check',
    subtitle:
        'Find where rupees turned into crypto, or separate clean money on a frozen account.',
    tip: 'New here? Pick a job below — start with “Try example”.',
    changeJob: 'Change job',
    showAll: 'Show all tools',
} as const;

export const TIER = {
    deterministic: 'Deterministic',
    scored: 'Scored',
    boundary: 'Data boundary',
    deterministicHint: 'Ground truth — registry match or shared UTR join',
    scoredHint: 'Inference — a lead, not proof',
    boundaryHint: 'We cannot see further from this data',
} as const;

export const JOBS = {
    name_exit: {
        title: 'Name the crypto exit',
        blurb: 'Connect matching UPI/IMPS payments, then check if the beneficiary is a known exit.',
        primaryCta: 'Try the example',
    },
    clear_freeze: {
        title: 'Clear a frozen account',
        blurb: 'Mark NCRP-flagged credits as tainted and see how much balance is still clean.',
        primaryCta: 'Try the example',
    },
    show_all: {
        title: 'Show all tools',
        blurb: 'Power-user view — every Off-Ramp tool on one page.',
        primaryCta: 'Open all',
    },
} as const;

export const STITCH = {
    title: 'Connect matching payments',
    empty:
        'Paste statement legs as JSON, or try the built-in mule → seller example.',
    resultHint:
        'Green edge = same UTR on debit and credit (court-grade). Grey unstitched = we only see one side.',
    tryExample: 'Try example',
    run: 'Stitch by UTR',
    advancedNote:
        'Advanced: legs shaped like StatementFlow extract rows — { dr_cr, account, amount, ref_number }.',
} as const;

export const UTR = {
    title: 'Validate a UTR',
    empty: 'Optional if you already trust the reference number.',
    trySample: 'Try sample',
    run: 'Decode',
    invalid: 'Invalid — not a safe join key',
    tamper: 'Tamper signal: embedded date ≠ statement date',
} as const;

export const MATCH = {
    title: 'Name the beneficiary',
    empty: 'Enter a VPA (or paste a UPI payment QR) to check if this payee is a known crypto exit.',
    check: 'Check off-ramp',
    resolve: 'Resolve payee',
    resolveHint: 'Fill holder name from UPI QR / bank verify',
    moreFields: 'Account + IFSC (optional)',
    boundaryPlain:
        'Not in our exit registry yet — that means unknown, not “safe”.',
    noHolder: 'No holder name resolved',
    openWorkbench: 'Open in Workbench (L3 triage)',
} as const;

export const TRIAGE = {
    title: 'Frozen-account triage',
    empty:
        'Paste the frozen account’s legs and list the NCRP-flagged credit UTR(s). We show how much balance is still clean.',
    tryExample: 'Try example',
    run: 'Run triage',
    cleanReleasable: 'Clean releasable',
    advancedNote:
        'Taint follows first-in-first-out from the flagged credits; untouched balance is releasable.',
} as const;

export const SOF = {
    title: 'Source-of-funds check',
    empty: 'Looks for a P2P crypto-selling pattern on inflows (many UPI credits, then a large debit).',
    tryExample: 'Try example',
    run: 'Assess SoF',
    triggered: 'EDD triggered',
    clear: 'CLEAR — no SoF signal',
    notTested: 'Not enough data to test',
} as const;

export const STYLES = {
    input:
        'w-full text-sm px-3 py-2 bg-background border border-input rounded-md focus:outline-none focus:ring-2 focus:ring-primary/50',
    btn:
        'flex items-center justify-center gap-1.5 px-4 py-2 bg-primary text-primary-foreground text-sm font-medium rounded-md hover:bg-primary/90 transition-colors disabled:opacity-50',
    btnSecondary:
        'flex items-center justify-center gap-1.5 px-4 py-2 bg-secondary text-secondary-foreground text-sm font-medium rounded-md border border-border hover:bg-secondary/80 transition-colors disabled:opacity-50',
    label: 'block text-xs font-medium text-muted-foreground mb-1',
    card: 'bg-card border border-border rounded-lg p-5 space-y-4',
} as const;
